module.exports = __webpack_public_path__ + "img/parse-server.0c079c16.png";